import React, { useState, useEffect } from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Main from './Quotation/Main';
import Form from './Quotation/Form';

import {
  getDataWithComp,
  getDocStatusColour,
  getAlert,
  getMaxDocNo,
  getClearLocalStorage
} from '../../../utils/SamuiUtils';

import { getReport } from '../../../utils/ReportUtils';

const Quotation = () => {
  const [mode, setMode] = useState('');
  const [dataMasterList, setDataMasterList] = useState([]);
  const [statusColours, setStatusColours] = useState([]);
  const [maxDocNo, setMaxDocNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      await getClearLocalStorage();
      setMode('S');
      fetchRealtime();
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp('API_0601_QT_H', 'ORDER BY Doc_No DESC');
      const docStatusColour = await getDocStatusColour('QT', 'Doc_Status');

      if (masterList && masterList.length > 0) {
        const sortedData = masterList.sort((a, b) => a.Doc_Id - b.Doc_Id);
        setDataMasterList(sortedData);
      }

      if (docStatusColour && docStatusColour.length > 0) {
        setStatusColours(docStatusColour);
      }

      // หาค่าสูงของ DocNo ใน PR_H
      const findMaxDocNo = await getDataWithComp('API_0601_QT_H', 'ORDER BY Doc_No DESC');
      // รอพี่คินทำ QT
      const maxDoc = getMaxDocNo(findMaxDocNo, 'QT');
      setMaxDocNo(maxDoc);
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const onPageInsert = () => {
    setMode('I')
  };

  const onRowSelected = (docNo) => {
    setMaxDocNo(docNo);
    setMode('U');
  };
  return (
    <div className="PurchaseRequest">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === 'S' ? (
                <Main
                  masterList={dataMasterList}
                  statusColours={statusColours}
                  name={'ใบเสนอราคา'}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(docNo) => onRowSelected(docNo)}
                  getReport={getReport}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  setMode={setMode}
                  name={'ใบเสนอราคา'}
                  maxDocNo={maxDocNo}
                  getReport={getReport}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quotation;
